let elts = {
	//screen stats
  	diagonal: document.getElementById("diagonal_in"),
  	width: document.getElementById("width_in"),
    height: document.getElementById("height_in"),
  	aspect: document.getElementById("aspect_select"),
  	gain: document.getElementById("gain_in"),
	
	//projector stats
  	lumens: document.getElementById("lumens_in"),
	
	//calculator options
  	sizeUnit: document.getElementById("sizeUnit_select"),		//values of this are multipliers to convert area to square inches
  	lumenType: document.getElementById("lumenType_select"),		//multiplier for any brightness input unit options
  	brightUnit: document.getElementById("brightUnit_select"),	//{multiplier, abbreviation} for any luminance output unit options
	
	//output element
  	out: document.getElementById("brightness_out")
}

for (let n in elts) {
  if (n==="out") continue;	//browsers shouldn't go into loop, but some might..
  elts[n].onchange = calculateChange;
}

function calculateFtL(precision=2) {
  	let width = parseFloat(elts.width.value);
  	let height = parseFloat(elts.height.value);
  	let unit = parseFloat(elts.sizeUnit.value);
	let area = unit * width * height;
  
  	let lumens = parseFloat(elts.lumens.value);
	let bright = lumens * elts.lumenType.value / area;
  	
  	let gain = parseFloat(elts.gain.value);
  	let bUnit = parseInt(elts.brightUnit.value);
  	let ftl = bright * gain * bUnit;
  	
  	let multiplier = 10 ** precision;
  	elts.out.innerHTML = Math.round(ftl * multiplier) / multiplier + " " + elts.brightUnit.selectedOptions[0].label;
}

//these changes affect the calculated FtL value
function calculateChange(evt) {
  let d = parseFloat(elts.diagonal.value);
  let w = parseFloat(elts.width.value);
  let h = parseFloat(elts.height.value);
  let r = elts.aspect.value;
  
  let h2, w2, d2;
  
  //which thing changed?
  let elt = evt.target;
  switch(elt) {
    
    case elts.diagonal:
    case elts.aspect:
      h2 = d / Math.sqrt(r**2 + 1);
      w2 = r * h2;
      
      elts.height.value = toPlaces(h2);
      elts. width.value = toPlaces(w2);
      
      calculateFtL();
      break;
    
    case elts.width:
      h2 = w / r;
      d2 = Math.sqrt(w**2 + h**2);
      
      elts.height.value = toPlaces(h2);
      elts.diagonal.value = toPlaces(d2);
      
      calculateFtL();
      break;
    
    case elts.height:
      w2 = r * h;
      d2 = Math.sqrt(w**2 + h**2);
      
      elts.width.value = toPlaces(w2);
      elts.diagonal.value = toPlaces(d2);
      
      calculateFtL();
      break;
    
    default:	//measurement unit, gain, brightness, brightness unit
      calculateFtL();
      break;
  }
}

/*** utility functions ***/
function toPlaces(value, places=2){
  let mult = 10 ** places;
  return Math.round(value * mult) / mult;
}